export const ADD_TIMEZONES = 'ADD_TIMEZONES';

export function addTimezones(timezones: any[]) {
    return {
        type: ADD_TIMEZONES,
        payload: timezones,
    };
}
